import { Link as MuiLink, type LinkProps as MuiLinkProps } from "@mui/material";
import { createLink } from "@tanstack/react-router";

type BaseLinkProps = Pick<MuiLinkProps, "underline" | "onClick"> & {
  children: React.ReactNode;
};

export const Link = createLink(function BaseLink({
  children,
  ...restProps
}: BaseLinkProps) {
  return <MuiLink {...restProps}>{children}</MuiLink>;
});
